/**
 * Геокодер Яндекса — общий с админкой, живёт в `@dorixona/api/maps`. Ключ
 * клиента — `VITE_YANDEX_GEOCODER_KEY` (нет своего — ключом карт: из пула на
 * сервере или, без пула, из сборки), его даёт `useGeocoderKeySource`.
 */
import { searchAddresses as search, type MapKeySource } from '@dorixona/api/maps'
import type { DeliveryAddress } from './api'

export { GEOCODER_URL, geocoderLang, reverseGeocode } from '@dorixona/api/maps'

/** Адреса по набранному тексту — только в Ташкенте. Адрес доставки — без подписи района. */
export async function searchAddresses(
  keys: MapKeySource,
  query: string,
  lang: string,
): Promise<DeliveryAddress[]> {
  return (await search(keys, query, lang)).map(({ label, lat, lng }) => ({ label, lat, lng }))
}
